import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubstackService {

  private readonly RSS_SERVICES = [
    `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent('https://lightcapgroupok.substack.com/feed')}`,
    `https://api.rss-parser.com/api/rss?url=${encodeURIComponent('https://lightcapgroupok.substack.com/feed')}`,
    `https://rss-to-json-serverless-api.vercel.app/api?url=${encodeURIComponent('https://lightcapgroupok.substack.com/feed')}`,
    `https://rss2json.now.sh/?url=${encodeURIComponent('https://lightcapgroupok.substack.com/feed')}`
  ];

  constructor(private http: HttpClient) {}

  getPosts(): Observable<any[]> {
    return this.tryAllRssServices(0);
  }

  private tryAllRssServices(index: number): Observable<any[]> {
    if (index >= this.RSS_SERVICES.length) {
      return of(this.getFallbackPosts());
    }

    return this.http.get(this.RSS_SERVICES[index]).pipe(
      map((response: any) => this.transformRssData(response, index)),
      catchError(() => this.tryAllRssServices(index + 1))
    );
  }

  private transformRssData(response: any, serviceIndex: number): any[] {
    let items = [];

    switch (serviceIndex) {
      case 0: items = response.items || []; break;
      case 1: items = response || []; break;
      case 2: items = response.items || response || []; break;
      case 3: items = response.items || []; break;
      default: items = [];
    }

    return items.map((item: any, index: number) => {
      const title = item.title || `Publicación ${index + 1}`;
      const description = item.description || '';
      const content = item.content || '';
      const link = item.link || item.url;
      const pubDate = item.pubDate || item.published;

      return {
        id: index + 1,
        name: title.trim(),
        description: description,   // 💥 ESTE es el que querés mostrar
        excerpt: this.generateExcerpt(content),
        publishDate: new Date(pubDate),
        link: link
      };
    });
  }

  private generateExcerpt(html: string): string {
    if (!html) return '';
    const clean = html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
    return clean.substring(0, 160) + (clean.length > 160 ? '...' : '');
  }

  private getFallbackPosts(): any[] {
    return [
      {
        id: 1,
        name: 'Planificación estratégica en tiempos de volatilidad',
        description: 'La volatilidad como característica estructural de la economía argentina...',
        excerpt: '',
        publishDate: new Date(),
        link: 'https://lightcapgroupok.substack.com'
      }
    ];
  }
}
